// @ts-strict-ignore
import toastr from "toastr";

import "toastr/build/toastr.min.css";

const defaultOptions = {
	closeButton: true,
	debug: false,
	newestOnTop: false,
	progressBar: true,
	positionClass: "toast-top-right",
	preventDuplicates: true,
	onclick: null,
	showDuration: 300,
	hideDuration: 2000,
	timeOut: 15000,
	extendedTimeOut: 1000,
	showEasing: "swing",
	hideEasing: "linear",
	showMethod: "fadeIn",
	hideMethod: "fadeOut"
};

const showWarning = (message: string, header?: string, options?) : void => {
	toastr.options = options || defaultOptions;
	toastr.warning(message, header);
};

const showInformation = (message: string, header?: string, options?) : void => {
	toastr.options = options || defaultOptions;
	toastr.info(message, header);
};

const showSuccess = (message: string, header?: string, options?) : void => {
	toastr.options = options || defaultOptions;
	toastr.success(message, header);
};

const showError = (message, header?, options?) : void => {
	toastr.options = options || defaultOptions;
	toastr.error(message, header);
};

const discardNotification = () : void => {
	toastr.remove();
};

export {
	showWarning,
	showSuccess,
	showError,
	showInformation,
	discardNotification
};
